import { Select } from "@/components/select";
import { __ } from "@wordpress/i18n";

export const slugMaxLengthOptions = [
    {
        value: "short",
        label: __("Short (up to 20 characters)", "antimanual"),
        max: 20,
    },
    {
        value: "medium",
        label: __("Medium (up to 50 characters)", "antimanual"),
        max: 50,
    },
    {
        value: "long",
        label: __("Long (up to 100 characters)", "antimanual"),
        max: 100,
    },
];

type Props = React.HTMLProps<HTMLDivElement> & {
    slugMaxLength: (typeof slugMaxLengthOptions)[0];
    setSlugMaxLength(length: (typeof slugMaxLengthOptions)[0]): void;
};

export function SlugMaxLength({ slugMaxLength, setSlugMaxLength }: Props) {
    const getLength = (length: string) => {
        const lengthOption = slugMaxLengthOptions.find((option) => option.value === length);
        return lengthOption || slugMaxLengthOptions[1];
    };

    return (
        <Select
            value={slugMaxLength.value}
            onChange={(value) => setSlugMaxLength(getLength(value))}
            label={__("Slug Max Length", "antimanual")}
            help={__("Select the maximum length for the slug of the generated posts.", "antimanual")}
            options={slugMaxLengthOptions}
        />
    );
}
